import React from 'react';

type DisplayResaProps = {
  resa: string | null;
};

export const DisplayResa: React.FC<DisplayResaProps> = ({ resa }) => {

  if (!resa || resa.length === 0) return <span></span>;

  const mainText = resa.slice(0, -1);
  const lastChar = resa.slice(-1);

  return (
    <span>
      {mainText}
      <sup>{lastChar}</sup>
    </span>
  );
};

